import { ErrorCard, RetryButton } from './styles';

interface DashboardErrorProps {
  onRetry: () => void;
}

/** Явное состояние ошибки загрузки дашборда — вместо «тихих нулей». */
export function DashboardError({ onRetry }: DashboardErrorProps) {
  return (
    <ErrorCard role="alert">
      <div>
        <strong>Не удалось загрузить данные дашборда.</strong>
        <p>
          Возможно, истекла сессия или пропала связь. Показатели ниже не отражают реальные
          цифры — обновите страницу или повторите.
        </p>
      </div>
      <RetryButton type="button" onClick={onRetry}>
        Обновить
      </RetryButton>
    </ErrorCard>
  );
}
